import React from 'react';
import { HousingProvider } from '../../contexts/HousingContext';
import { DesignVariantSwitch } from '../../components/experience/DesignVariantSwitch';
import { FindHomeVariantA } from '../../components/housing/FindHomeVariantA';
import { FindHomeVariantB } from '../../components/housing/FindHomeVariantB';

/**
 * Find a home.
 *
 * ONE housing experience presented through two approved designs. The provider
 * sits ABOVE the design controller, so a handover changes the presentation
 * layer and nothing else — search, filters, sort, shortlist, selected home,
 * map position and list/map preference all survive it, because neither design
 * owns any of them.
 *
 * Scroll is deliberately NOT reset here: both designs present the same result
 * list in the same order, so the property someone is reading is still the
 * property in front of them.
 */
export function FindHome() {
  return <HousingProvider data-id="element-10659" data-mp="27tqzsh8de4w1">
      <DesignVariantSwitch surface="HOUSING_FIND_HOME" render={design => design === 'DESIGN_2' ? <FindHomeVariantB data-id="element-10661" data-mp="j130bk8m7w22" /> : <FindHomeVariantA data-id="element-10662" data-mp="j1m8wacdl83f" />} data-id="element-10660" data-mp="27s66euxskrzr" />
    </HousingProvider>;
}